<ng-container *ngIf="dataLoaded && responseOk">
  <iframe title="cita online"
    id="health-app-iframe"
    allow="geolocation"
    [src]="iframeUrlSafeResource"
    class="iframe-full-page"
    [ngClass]="{'iframe-min-height': minHeight, 'mapfre-visibility-hidden': hideIframe}"
    #iframe>
  </iframe>
</ng-container>


<ng-container *ngIf="dataLoaded && !responseOk">
  <app-request-result
    imageKo="ko-generic"
    [hideBtns]="hideKoBtns"
    (back)="goBack()"
    (ok)="goHomePage()"
    [success]="false"
    [titleFirst]="true"
  >
  </app-request-result>
</ng-container>
